module.exports = __webpack_public_path__ + "5b584904.woff2";